import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faAt } from "@fortawesome/free-solid-svg-icons";
import { Form, DateRangePicker, SelectPicker, InputNumber, Button, Schema, Row, Grid, Col, Message } from 'rsuite';
import BookingModal from "./BookingModal";
import { useTranslation } from 'react-i18next';

function Book({ roomsData, selectedRoom, setSelectedRoom }) {
    const { t } = useTranslation();
    const [checkinDate, setCheckinDate] = useState("");
    const [checkoutDate, setCheckoutDate] = useState("");
    const [adults, setAdults] = useState(1);
    const [rooms, setRooms] = useState(1);
    const [room, setRoom] = useState(1);
    const [modalOpen, setModalOpen] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const { beforeToday } = DateRangePicker
    const [formValue, setFormValue] = useState({
        dateRange: [],
        roomType: selectedRoom,
        adults: 1,
        rooms: 1
    });

    useEffect(() => {
        setFormValue(prevValue => ({
            ...prevValue,
            roomType: selectedRoom
        }));
    }, [selectedRoom]);

    const Field = React.forwardRef((props, ref) => {
        const { name, message, label, accepter, error, ...rest } = props;
        return (
            <Form.Group controlId={`${name}-10`} ref={ref} className={error ? 'has-error' : ''}>
                <Form.ControlLabel>{label} </Form.ControlLabel>
                <Form.Control name={name} accepter={accepter} errorMessage={error} {...rest} />
                <Form.HelpText>{message}</Form.HelpText>
            </Form.Group>
        );
    });

    const today = new Date();
    const tomorrow = new Date();
    tomorrow.setDate(today.getDate() + 1)
    let form = React.useRef();

    const handleSubmit = () => {
        console.log("Form submitted:", {
            formValue
        });
        
        // Validation spécifique pour le type de chambre
        if (!formValue.roomType || formValue.roomType === '') {
            console.log("Erreur: Aucun type de chambre sélectionné");
            return;
        }
        
        // Validation spécifique pour les dates
        if (!formValue.dateRange || formValue.dateRange.length !== 2) {
            console.log("Erreur: Dates non sélectionnées");
            return;
        }
        
        if (!form.current.check()) {
            console.log("Erreur de validation du formulaire!");
            return;
        }
        
        const room = roomsData.find(room => room.titleKey ? t(room.titleKey) === selectedRoom : room.title === selectedRoom);
        
        if (!room) {
            console.log("Erreur: Chambre non trouvée");
            return;
        }

        setRoom(room);
        setModalOpen(true);
    };
    const { ArrayType, NumberType, StringType } = Schema.Types;
    const model = Schema.Model({
        dateRange: ArrayType()
            .minLength(2, t("booking.validation.dateRequired"))
            .isRequired(t('booking.validation.fieldRequired')),
        roomType: StringType()
            .isRequired(t('booking.validation.roomRequired'))
            .minLength(1, t('booking.validation.roomRequired')),
        adults: NumberType().min(1, t('booking.validation.minNumber')).isRequired(t('booking.validation.fieldRequired')),
        rooms: NumberType().min(1, t('booking.validation.minNumber')).isRequired(t('booking.validation.fieldRequired'))
    });

    const roomData = roomsData.map(item => ({ 
        label: item.titleKey ? t(item.titleKey) : item.title, 
        value: item.titleKey ? t(item.titleKey) : item.title 
    }))


    return (<>
        {successMessage !== "" &&
            <Message type="success" showIcon>
                {successMessage}
            </Message>}
        <div className="book" id="book">
            <h2>{t('booking.title')}</h2>

            <p>
                {t('booking.description')}
            </p>
            <div className="book-form book-form2">
                <span className="form-item">
                    <a href="tel:+33325252510">
                        <FontAwesomeIcon icon={faPhone} /><br />
                        03 25 25 25 10
                    </a>
                </span>
                <span className="form-item">
                    <a href="mailto:lhotelromilly@gmail.com">
                        <FontAwesomeIcon icon={faAt} /><br />
                        lhotelromilly@gmail.com
                    </a>
                </span>
            </div>
            <div>
                <Form
                    formValue={formValue}
                    onChange={formValue => setFormValue(formValue)}
                    ref={form}
                    model={model}
                >
                    <Grid fluid>
                        <Row>

                                <Col xl={5} lg={4} md={12}>
                                    <label>{t('booking.dateLabel')}</label><br />
                                    <div className="customDatePickerWidth">
                                        <Field
                                            name="dateRange"
                                            placeholder={t('booking.datePlaceholder')}
                                            defaultCalendarValue={[today, tomorrow]}
                                            editable={false}
                                            shouldDisableDate={beforeToday()}
                                            accepter={DateRangePicker}
                                            size="lg"
                                            onChange={(e) => {
                                                setCheckinDate(e[0])
                                                setCheckoutDate(e[1])
                                            }}
                                        />
                                    </div>
                                </Col>

                                <Col xl={5} lg={4} md={12}>
                                    <label>{t('booking.roomTypeLabel')}</label> <br />
                                    <div className="customDatePickerWidth">
                                        <Field
                                            name="roomType"
                                            data={roomData}
                                            placeholder={t('booking.roomTypePlaceholder')}
                                            accepter={SelectPicker}
                                            value={selectedRoom}
                                            onChange={(value) => {
                                                setSelectedRoom(value);
                                                setFormValue(prev => ({
                                                    ...prev,
                                                    roomType: value
                                                }));
                                            }}
                                            size="lg"
                                            searchable={false}
                                            cleanable={false}
                                        />
                                    </div>
                                </Col>


                                <Col xl={5} lg={4} md={10}>
                                    <label>{t('booking.personsLabel')}</label><br />
                                    <Field
                                        name="adults"
                                        min={1}
                                        accepter={InputNumber}
                                        onChange={setAdults}
                                        size="lg"
                                    />
                                </Col>

                                <Col xl={5} lg={4} md={10}>
                                    <label>{t('booking.roomsLabel')}</label><br />
                                    <Field
                                        name="rooms"
                                        min={1}
                                        accepter={InputNumber}
                                        onChange={setRooms}
                                        size="lg"
                                    />
                                </Col>

                                <Col xl={4} lg={4} md={2}>
                                    <Button type="submit" className="btn" appearance="primary" onClick={handleSubmit} style={{ margin: "27px auto" }}>
                                        {t('booking.searchButton')}
                                    </Button>
                                </Col>

                        </Row>
                    </Grid>
                </Form>
            </div>
            <BookingModal showModal={modalOpen} setShowModal={setModalOpen} selectedRoomData={room} selectedRoom={selectedRoom} checkinDate={checkinDate} checkoutDate={checkoutDate} person={adults} nbrooms={rooms} setSuccessMessage={setSuccessMessage} />
        </div>
    </>
    );
}

export default Book;
